import { AI_AGREEMENT_URL } from '@/features/ai_agents_setting/components/AiAgentServicesSetting/constants';
import { useTranslation } from '@/i18n';
import { TextLink } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { FC, memo } from 'react';
import styles from '../index.module.scss';

const cx = classNames.bind(styles);

export const AiSuggestTerm: FC = memo(() => {
  const { t } = useTranslation();
  return (
    <div
      className={cx(styles['ai-suggest-term'])}
      data-testid='ai-suggest-term'
    >
      <span>{t('received_invoice.uploader.ai_suggest_term_prefix')}</span>
      <TextLink href={AI_AGREEMENT_URL} target='_blank'>
        {t('received_invoice.uploader.ai_suggest_term_link')}
      </TextLink>
      <span>{t('received_invoice.uploader.ai_suggest_term_suffix')}</span>
    </div>
  );
});
AiSuggestTerm.displayName = 'AiSuggestTerm';
